import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";

import { Content_TQC2090_R01 } from "./Content_TQC2090_R01";
import { TQC2090_R01Dto } from "./Dto_TQC2090_R01";
import { Info_TQC2090_R01 } from "./Info_TQC2090_R01";
import { SearchSection_TQC2090_R01 } from "./SearchSection_TQC2090_R01";
import { Table_TQC2090_R01 } from "./Table_TQC2090_R01";

/**
 * 초중종검사 결과등록(JC) 컨테이너.
 *
 * 선택한 검사연월의 1일~말일 × 검사항목(재공품 WIP / 초중종검사 FML)을 행으로 만들고
 * 초품·중품·종품 각 5회 측정값을 등록한다.
 * 공정라인(아연라인 / 니켈크롬라인)은 탭으로 전환한다.
 */
export const Container_TQC2090_R01 = () => {
	useFetchActionbarAuth("TQC2090_R01");

	const gridRef = useRef<AgGridReact<TQC2090_R01Dto> | null>(null);

	const {
		clickable, setClickable,
		defaultTQC2090_R01Row,
		fetchData,
		handleLineChange,
		handleSaveClick,
		handleDeleteClick,
		handleExcelClick,
		handlePrintClick,
		initContainerData,
	} = Content_TQC2090_R01({ gridRef });

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={() => {}}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onPrintClick={handlePrintClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_TQC2090_R01 />
			<Info_TQC2090_R01 />

			<div className="flex-1 flex">
				<div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
					<Table_TQC2090_R01
						clickable={clickable}
						setClickable={setClickable}
						gridRef={gridRef}
						defaultTQC2090_R01Row={defaultTQC2090_R01Row()}
						onChangeLine={handleLineChange}
					/>
				</div>
			</div>

			<Message />
		</div>
	);
};
